import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=43436dc6&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=43436dc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43436dc6",
  null
  
)

export default component.exports